import { LTUtils } from "../../LTGame/LTUtils/LTUtils";
import Vector3Ex from "../../LTGame/LTUtils/Vector3Ex";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import LTRes from "../../LTGame/Res/LTRes";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import LTUI from "../../LTGame/UIExt/LTUI";
import UI_Get from "../../ui/Main/UI_Get";
import GlobalUnit from "../common/GlobalUnit";
import ResDefine from "../common/ResDefine";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
export class UI_GetMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_GetMediator();
            this._instance._classDefine = UI_Get;
        }
        return this._instance;
    }
    _OnShow() {
        const _super = Object.create(null, {
            _OnShow: { get: () => super._OnShow }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super._OnShow.call(this);
            // GlobalUnit.game.camera.TurnOff();
            if (LTPlatform.instance.platform == EPlatformType.WX) {
                LTPlatform.instance.ShowBannerAd();
            }
            this.ui.m_btn_close.onClick(this, this.Hide);
            this.ui.m_btn_get.onClick(this, this.GetReward);
            yield this._createCamera();
            yield this._loadModel();
        });
    }
    GetReward() {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
            if (res) {
                GlobalUnit.dataManager.UnlockItem(1, this._openParam.id);
                this.Hide();
            }
        });
    }
    _createCamera() {
        return __awaiter(this, void 0, void 0, function* () {
            let rtt = this._ui.m_img_display;
            rtt.visible = false;
            LTUI.LockScreen();
            this._root = yield LTRes.LoadAndGet(ResDefine.FixScene("ZS_EggUnlock"));
            Laya.stage.addChild(this._root);
            this._node = LTUtils.FindChild(this._root, "ZS_01/xuanzhuan/jiaose");
            let camera = LTUtils.FindChild(this._root, "ZS_01/daCamera/Camera");
            // 注意格式只能用r8g8b8a8否则ip6不支持
            this._cacheRt = new Laya.RenderTexture(rtt.width, rtt.height, Laya.RenderTextureFormat.R8G8B8A8, Laya.RenderTextureDepthFormat.DEPTH_16);
            let cacheImage = new fgui.GImage();
            this._ui.addChildAt(cacheImage, this._ui.getChildIndex(rtt) + 1);
            cacheImage.image.texture = new Laya.Texture(this._cacheRt);
            cacheImage.setPivot(rtt.pivotX, rtt.pivotY, rtt.pivotAsAnchor);
            cacheImage.setXY(rtt.x, rtt.y);
            camera.renderTarget = this._cacheRt;
            LTUI.UnlockScreen();
            rtt.visible = true;
        });
    }
    _loadModel() {
        return __awaiter(this, void 0, void 0, function* () {
            LTUI.LockScreen();
            this._node.destroyChildren();
            let node;
            let config;
            config = this._openParam;
            yield LTRes.LoadAsync(ResDefine.FixPath(config.model_path));
            node = LTRes.Get(ResDefine.FixPath(config.model_path));
            if (node) {
                this._node.addChild(node);
                let trs = node.transform;
                let v = Vector3Ex.temp;
                v.setValue(config.offset_pos[0], config.offset_pos[1], config.offset_pos[2]);
                trs.localPosition = v;
                v.setValue(config.offset_scale[0], config.offset_scale[1], config.offset_scale[2]);
                trs.localScale = v;
                v.setValue(config.offset_rot[0], config.offset_rot[1], config.offset_rot[2]);
                trs.localRotationEuler = v;
            }
            LTUI.UnlockScreen();
        });
    }
    _OnHide() {
        return __awaiter(this, void 0, void 0, function* () {
            LTUI.LockScreen();
            GlobalUnit.game.camera.TurnOn();
            if (this._root) {
                this._root.destroy();
                this._root = null;
                LTRes.Unload(ResDefine.FixScene("ZS_EggUnlock"));
            }
            LTUI.UnlockScreen();
            if (LTPlatform.instance.platform == EPlatformType.WX) {
                LTPlatform.instance.HideBannerAd();
            }
            // UI_SkillMediator.instance.Show();
        });
    }
}
